import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = { districtId: Number }
  static targets = [ "onlineCount", "header", "messages" ]

  connect() {
    this.subscription = null
    this.heartbeatInterval = null
    this.#subscribe()
  }

  disconnect() {
    this.#unsubscribe()
  }

  #subscribe() {
    if (this.subscription) return

    this.subscription = consumer.subscriptions.create(
      { channel: "ChatChannel", district_id: this.districtIdValue },
      {
        connected: () => this.#startHeartbeat(),
        disconnected: () => this.#stopHeartbeat(),
        received: (data) => {
          if (data.count !== undefined && this.hasOnlineCountTarget) {
            this.onlineCountTarget.textContent = data.html
          }
        }
      }
    )
  }

  #unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
    this.#stopHeartbeat()
  }

  #startHeartbeat() {
    if (this.heartbeatInterval) return
    this.heartbeatInterval = setInterval(() => {
      if (this.subscription) this.subscription.perform("heartbeat")
    }, 30000)
  }

  #stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
      this.heartbeatInterval = null
    }
  }

  handleScroll() {
    if (!this.hasHeaderTarget || !this.hasMessagesTarget) return
    if (this.messagesTarget.scrollTop > 0) {
      this.headerTarget.classList.add("scrolled")
    } else {
      this.headerTarget.classList.remove("scrolled")
    }
  }
}
